import { render, staticRenderFns } from "./UpdateDeliveryInfoDialog.vue?vue&type=template&id=4387afc0&scoped=true&lang=pug&"
import script from "./UpdateDeliveryInfoDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdateDeliveryInfoDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4387afc0",
  null
  
)

export default component.exports